/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { useTraversal } from '@guillotinaweb/react-gmi'
import { Button, Drawer, Form, Input, message, Select } from 'antd'
import { ErpClientContext } from '../services/erp'
import { ALL_COUNTRIES } from '../consts'
import PriceComparatorTable from './price-comparator-table'
import { ConsoleSqlOutlined } from '@ant-design/icons'

const initial = {
  URL: '',
}

export function PriceComparatorTab() {
  const [form] = Form.useForm()
  const [selectedInTables, setSelectedRowKeys] = useState({})
  const selectedRowKeys = Object.values(selectedInTables).flat()
  const erp = useContext(ErpClientContext)
  const [data, setData] = useState()
  const [rest, setRest] = useState()
  const [country, setCountry] = useState('es')
  const [updating, setUpdating] = useState(false)
  const [deleting, setDeleting] = useState(false)
  const [drawer, showDrawer] = useState(false)
  const Ctx = useTraversal()
  const product = Ctx.state.context
  const productId = product['@name']
  const optionCountries = [
    ...new Set(
      Object.keys(product.opciones).map((key) => `${key[0]}${key[1]}`)
    ),
  ]

  function getSelectedURLs() {
    const urls = selectedRowKeys.map((key) => key.split('-///-')[0])
    return [...new Set(urls)]
  }

  async function deleteRows() {
    const urls = getSelectedURLs()
    if (
      window.confirm(
        `Are you sure you want to remove the selected URLs?\n\n- ${urls.join(
          '\n- '
        )}`
      )
    ) {
      setDeleting(true)
      try {
        const dataToRemove = urls.map((url) => ({ group: productId, url }))
        await erp.deletePriceComparator(dataToRemove)
        setData((d) => d.filter((d) => !urls.includes(d.url)))
      } catch (e) {
        message.error(`There was an error removing the data: ${e.message}`)
      } finally {
        setDeleting(false)
      }
    }
  }

  async function updateRows() {
    const urls = getSelectedURLs()
    if (
      window.confirm(
        `Are you sure you want to update the selected URLs?\n\n- ${urls.join(
          '\n- '
        )}`
      )
    ) {
      setUpdating(true)
      try {
        const dataToUpate = urls.map((url) => ({ group: productId, url }))
        await erp.upsertPriceComparator(dataToUpate, country)
        await init()
        setSelectedRowKeys({})
        message.success('Updated successfully')
      } catch (e) {
        message.error(`There was an error updating the data: ${e.message}`)
      } finally {
        setUpdating(false)
      }
    }
  }

  async function onFinish({ URL }) {
    try {
      const dataToUpdate = [{ group: productId, url: URL }]
      await erp.upsertPriceComparator(dataToUpdate, country)
      await init()
      setSelectedRowKeys({})
      message.success('Data updated with the new values')
      form.resetFields()
    } catch (e) {
      message.error(`There was an error adding the URL: ${e.message}`)
    } finally {
      showDrawer(false)
    }
  }

  useEffect(() => {
    init()
  }, [])
  async function init() {
    const [resData, restOfUrls] = await erp.getPriceComparator(productId)
    setData(resData)
    setRest(restOfUrls)
  }

  return (
    <>
      <div
        style={{
          backgroundColor: 'white',
          display: 'flex',
          padding: 10,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h1 className="title is-size-4 is-primary">Price comparator</h1>
        <div>
          <Select
            style={{ minWidth: 120 }}
            defaultValue={country}
            onChange={setCountry}
          >
            {optionCountries.map((c) => (
              <Select.Option value={c}>{ALL_COUNTRIES[c]}</Select.Option>
            ))}
          </Select>
          <Button
            disabled={!selectedRowKeys.length || deleting}
            type="primary"
            style={{ marginLeft: 10 }}
            onClick={deleteRows}
          >
            {updating ? 'Deleting...' : 'Delete selected'}
          </Button>
          <Button
            disabled={!selectedRowKeys.length || updating}
            type="primary"
            style={{ marginLeft: 10 }}
            onClick={updateRows}
          >
            {updating ? 'Updating...' : 'Update selected'}
          </Button>
          <Button
            style={{ marginLeft: 10 }}
            type="primary"
            onClick={() => showDrawer(true)}
          >
            + Add URL
          </Button>
        </div>
        <Drawer
          title="Add URL"
          width={600}
          onClose={() => showDrawer(false)}
          visible={drawer}
          bodyStyle={{ paddingBottom: 80 }}
        >
          <Form form={form} onFinish={onFinish} initialValues={initial}>
            <Form.Item
              label="URL"
              name="URL"
              rules={[{ required: true, message: 'Please input the URL' }]}
            >
              <Input type="url" />
            </Form.Item>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
              }}
            >
              <div style={{ margin: '10px 0', fontStyle: 'italic' }}>
                The delivery county of this URL is:{' '}
                <b>{ALL_COUNTRIES[country]}</b>
              </div>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Save new URL
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Drawer>
      </div>
      <PriceComparatorTable
        data={data}
        country={country}
        rest={rest}
        selectedInTables={selectedInTables}
        setSelectedRowKeys={setSelectedRowKeys}
        displayLinks={false}
      />
    </>
  )
}
